import React from 'react'
import Navbar from './Components/Navbar'
 
import {  Routes, Route } from "react-router-dom";
import About from './Components/About';
import Home from './Components/Home';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
 

function App() {
  return (
    <>
     
      <Navbar />
     
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about"  element={<About />} />
        <Route path="Contact" element={<Contact />} />
      </Routes>
      
     <Footer/>
    

    </>
  );
}

export default App;
